import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, commonData } from "@/mixins/index";
import addMessage from './component/addMessage.vue';
import parentStudentList from '../../teammanagemant/parentList/parentStudentList';
export default {
  name: "parent-list",
  components: {
    addMessage: addMessage,
    parentStudentList: parentStudentList
  },
  mixins: [loadMoreList, commonData],
  props: ['teamId'],
  data: function data() {
    return {
      tableData: [],
      total: 0,
      sendIds: [],
      ids: ''
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this.paramsData.page = page;

                _this.$api.parentUserList(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  team_id: _this.teamId
                })).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    passClick: function passClick(id) {
      var _this2 = this;

      this.$api.review({
        id: id,
        approved: true
      }).then(function (res) {
        if (res.code == 200) {
          _this2.$message.success('操作成功');

          _this2.getList(_this2.paramsData.page);
        } else {
          _this2.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.sendIds = e;
      this.ids = this.sendIds.map(function (item) {
        return item.id;
      }).toString();
    },
    sendMessage: function sendMessage() {
      this.$refs.addMessage.init(this.ids);
    }
  }
};